import { css } from 'styled-system/css';

/** The tinted, rounded board behind Studio's hero areas (a velvet glow in dark mode) */
export const heroCard = css({
  position: 'relative',
  borderRadius: 'panel',
  bg: 'linear-gradient(160deg, {colors.soft.mist.200}, #E2DFEC)',
  _dark: { bg: 'radial-gradient(80% 90% at 75% 20%, #2E2542, {colors.soft.plum.900} 70%)' },
});

/** A soft glow that breathes behind hero content */
export const glow = css({
  position: 'absolute',
  borderRadius: 'full',
  bg: 'radial-gradient(circle, {colors.glow}, transparent 62%)',
  filter: 'blur(24px)',
  pointerEvents: 'none',
});

/** Frosted glass (the floating "open for work" card) */
export const glass = css({
  bg: 'bg.glass',
  backdropFilter: 'blur(18px) saturate(1.3)',
  boxShadow: 'raised',
});
